import React, { SyntheticEvent } from 'react';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import { __t, applyTranslations } from 'utils/language';
import './styles.scss';

applyTranslations(require('./EntertainmentVideoProductReviewToggle.i18n.json'));

export function EntertainmentVideoProductReviewToggle({
  isEditMode,
  value,
  onChange
}: {
  isEditMode?: boolean,
  value: boolean | null,
  onChange?: (value: boolean) => void
}) {
  const label = __t('entertainmentVideoProductReviewToggle.label');

  if (isEditMode) {
    return (
      <InputCheckbox
        id="entertainment-video-product-review-toggle"
        checked={value}
        disabled={!isEditMode}
        label={label}
        labelClass="ent-video-product-review-toggle-label"
        onChange={(e: SyntheticEvent<HTMLInputElement>) =>
          onChange?.(e.currentTarget.checked)
        }
      />
    );
  }

  return value ? (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <SVGDynamicIcon
        name="exclamation-inside-circle-custom-bg"
        width={20}
        height={20}
        customColor="primary"
      />
      <span className="ent-video-product-review-toggle-label">{label}</span>
    </div>
  ) : null;
}
